var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7bc205526ff8383afc7579627d518f82f3adf65f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"7bc205526ff8383afc7579627d518f82f3adf65f"};
      